<!-- EDIT TASK MODAL -->
<ion-modal
    [isOpen]="editTaskModalVisible"
    [backdropDismiss]="false"
    (ionModalDidDismiss)="onCancelEditTask()"
    class="modal-m mobile-fullscreen"
>
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title
                    >{{ 'tasks.details.task-title' | translate }}
                    {{
                        currentTaskFormGroup?.get('version')?.value > -1
                            ? currentTaskViewMode === 'edit'
                                ? ('shared.edit' | translate | lowercase)
                                : ('shared.view' | translate | lowercase)
                            : ('shared.create' | translate | lowercase)
                    }}
                </ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="dark" (click)="onCancelEditTask()">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
            @if (taskQueueTotal > 1 && currentTaskFormGroup?.get('version')?.value === -1) {
                <ion-toolbar class="queue-toolbar" color="none">
                    <div class="queue-progress">
                        <div class="queue-info">
                            <span>{{ 'tasks.details.queue-multiple-info' | translate }}</span>
                            <span class="step-count">{{ taskQueueCurrent }} / {{ taskQueueTotal }}</span>
                        </div>
                        <ion-progress-bar [value]="taskQueueCurrent / taskQueueTotal"></ion-progress-bar>
                    </div>
                </ion-toolbar>
            }
        </ion-header>
        <ion-content>
            <div class="new-event-wrap" *ngIf="currentTaskFormGroup" [formGroup]="currentTaskFormGroup">
                <ion-grid>
                    <ion-row>
                        <ion-col size="12" size-lg="8">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title>{{ 'tasks.details.info-title' | translate }}</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col>
                                            <ion-input
                                                [label]="'tasks.details.form.name-label' | translate"
                                                labelPlacement="floating"
                                                fill="outline"
                                                mode="md"
                                                [placeholder]="'tasks.details.form.name-placeholder' | translate"
                                                formControlName="name"
                                                class="bg-light"
                                            ></ion-input>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col>
                                            <ion-textarea
                                                [label]="'tasks.details.form.description-label' | translate"
                                                labelPlacement="floating"
                                                fill="outline"
                                                mode="md"
                                                auto-grow="true"
                                                [placeholder]="'tasks.details.form.description-placeholder' | translate"
                                                formControlName="description"
                                                class="bg-light"
                                            ></ion-textarea>
                                        </ion-col>
                                    </ion-row>
                                    <ion-row>
                                        <ion-col size="12" size-md="6">
                                            <div
                                                class="dp-floating-field"
                                                [ngClass]="{
                                                    disabled:
                                                        !settingsSrv.currentUserRights.canManageTasks || currentTaskViewMode === 'view',
                                                }"
                                            >
                                                <div
                                                    class="field-outline-container"
                                                    [ngClass]="{ 'no-label': !minTimestampDatePickerValue }"
                                                >
                                                    <div class="field-outline-start"></div>
                                                    <div class="field-outline-notch">
                                                        <div class="notch-spacer">{{ 'tasks.details.form.start-label' | translate }}</div>
                                                    </div>
                                                    <div class="field-outline-end"></div>
                                                </div>
                                                <div
                                                    (click)="onDateItemClicked(minDatePicker)"
                                                    class="dp-ion-item-content-wrap dp-combo-picker-wrap bg-light"
                                                >
                                                    <input
                                                        class="dp-ion-input dp-fake-active-input"
                                                        [value]="minTimestampDatePickerValue"
                                                        [matDatepicker]="minDatePicker"
                                                        [readonly]="true"
                                                        [placeholder]="'tasks.details.form.start-placeholder' | translate"
                                                    />
                                                    <fa-icon
                                                        class="reset-picker-btn"
                                                        icon="xmark"
                                                        (click)="resetPicker($event, 'min')"
                                                        *ngIf="minTimestampDatePickerValue != null"
                                                    ></fa-icon>
                                                </div>
                                                <mat-datepicker
                                                    [touchUi]="utils.isPhone || utils.isTablet"
                                                    disabled="false"
                                                    (closed)="onDatePickerClosed(minDatePicker, 'min')"
                                                    #minDatePicker
                                                ></mat-datepicker>
                                            </div>
                                        </ion-col>
                                        <ion-col size="12" size-md="6">
                                            <div
                                                class="dp-floating-field"
                                                [ngClass]="{
                                                    disabled:
                                                        !settingsSrv.currentUserRights.canManageTasks || currentTaskViewMode === 'view',
                                                }"
                                            >
                                                <div
                                                    class="field-outline-container"
                                                    [ngClass]="{ 'no-label': !maxTimestampDatePickerValue }"
                                                >
                                                    <div class="field-outline-start"></div>
                                                    <div class="field-outline-notch">
                                                        <div class="notch-spacer">{{ 'tasks.details.form.end-label' | translate }}</div>
                                                    </div>
                                                    <div class="field-outline-end"></div>
                                                </div>
                                                <div
                                                    (click)="onDateItemClicked(maxDatePicker)"
                                                    class="dp-ion-item-content-wrap dp-combo-picker-wrap bg-light"
                                                >
                                                    <input
                                                        class="dp-ion-input dp-fake-active-input"
                                                        [value]="maxTimestampDatePickerValue"
                                                        [matDatepicker]="maxDatePicker"
                                                        [readonly]="true"
                                                        [placeholder]="'tasks.details.form.end-placeholder' | translate"
                                                    />
                                                    <fa-icon
                                                        class="reset-picker-btn"
                                                        icon="xmark"
                                                        (click)="resetPicker($event, 'max')"
                                                        *ngIf="maxTimestampDatePickerValue != null"
                                                    ></fa-icon>
                                                </div>
                                                <mat-datepicker
                                                    [touchUi]="utils.isPhone || utils.isTablet"
                                                    disabled="false"
                                                    (closed)="onDatePickerClosed(maxDatePicker, 'max')"
                                                    #maxDatePicker
                                                ></mat-datepicker>
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                            <ion-card>
                                <ion-card-header>
                                    <ion-row>
                                        <ion-col class="d-flex ion-align-items-center">
                                            <ion-card-title>{{ 'tasks.details.related-title' | translate }}</ion-card-title>
                                            <ion-button
                                                class="info-hover-icon"
                                                size="small"
                                                fill="clear"
                                                dpTooltip
                                                [tooltipContent]="'tasks.details.related-info' | translate"
                                                [tooltipTrigger]="utils.mobileViewActive ? 'click mouseenter focus' : 'mouseenter focus'"
                                            >
                                                <fa-icon icon="info-circle"></fa-icon>
                                            </ion-button>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12" (click)="openProjectSelectionModal()">
                                            <div
                                                class="dp-floating-field"
                                                [ngClass]="{
                                                    disabled:
                                                        this.disabledProjectSelection ||
                                                        !settingsSrv.currentUserRights.canManageTasks ||
                                                        currentTaskViewMode === 'view',
                                                }"
                                            >
                                                <div
                                                    class="field-outline-container"
                                                    [ngClass]="{ 'no-label': currentTaskFormGroup.get('relatedProject').value == null }"
                                                >
                                                    <div class="field-outline-start"></div>
                                                    <div class="field-outline-notch">
                                                        <div class="notch-spacer">{{ 'tasks.details.form.project-label' | translate }}</div>
                                                    </div>
                                                    <div class="field-outline-end"></div>
                                                </div>
                                                <div class="dp-combo-picker-wrap bg-light ion-display-flex ion-align-items-center">
                                                    <div class="project-picker">
                                                        <ng-container *ngIf="selectedProjectName; else projectPlaceholder">
                                                            {{ selectedProjectName }}
                                                        </ng-container>
                                                        <ng-template #projectPlaceholder>
                                                            <span class="empty">{{
                                                                'tasks.details.form.project-placeholder' | translate
                                                            }}</span>
                                                        </ng-template>
                                                    </div>
                                                </div>
                                            </div>
                                        </ion-col>
                                        <ng-container *ngIf="currentTaskFormGroup.get('relatedProject').value != null">
                                            <ion-col size="12" *ngIf="currentTaskViewMode === 'edit'">
                                                <ion-input
                                                    (click)="maybeToggleDrawer('job', $event)"
                                                    mode="md"
                                                    fill="outline"
                                                    class="bg-light"
                                                    [placeholder]="'tasks.details.form.job-placeholder' | translate"
                                                    type="text"
                                                    [readonly]="true"
                                                    [disabled]="!settingsSrv.currentUserRights.canManageTasks"
                                                ></ion-input>
                                            </ion-col>
                                            <ion-col size="12">
                                                <div class="task-jobs" formArrayName="jobs">
                                                    <div
                                                        class="task-job"
                                                        *ngFor="let job of currentTaskJobsFormArray; index as jobIndex"
                                                        [formGroupName]="jobIndex"
                                                    >
                                                        <ion-chip
                                                            [color]="job.get('done').value ? 'success' : 'primary'"
                                                            class="task-job-chip"
                                                        >
                                                            @if (getJobDataById(job.get('jobId').value); as detailedJob) {
                                                                <ion-label
                                                                    >{{ detailedJob?.jobNumber }} - {{ detailedJob?.name }}
                                                                </ion-label>
                                                                <div class="task-job-chip-actions">
                                                                    <ion-checkbox
                                                                        *ngIf="currentTaskViewMode === 'edit'"
                                                                        color="success"
                                                                        class="job-finished-checkbox"
                                                                        formControlName="done"
                                                                        (ionChange)="onJobCheckboxChanged($event.detail.checked)"
                                                                    ></ion-checkbox>
                                                                    <ion-buttons>
                                                                        <ion-button
                                                                            size="small"
                                                                            color="primary"
                                                                            fill="solid"
                                                                            [ngClass]="{ round: utils.mobileViewActive }"
                                                                            [disabled]="detailedJobModalLoading"
                                                                            (click)="onViewDetailedJob(job.get('jobId').value)"
                                                                        >
                                                                            @if (
                                                                                detailedJobModalLoading &&
                                                                                detailedJobModalJobData != null &&
                                                                                detailedJobModalJobData._id === job.get('jobId').value
                                                                            ) {
                                                                                <fa-icon
                                                                                    icon="spinner-third"
                                                                                    animation="spin"
                                                                                    [slot]="utils.mobileViewActive ? 'icon-only' : 'start'"
                                                                                ></fa-icon>
                                                                            } @else {
                                                                                <fa-icon
                                                                                    icon="edit"
                                                                                    [slot]="utils.mobileViewActive ? 'icon-only' : 'start'"
                                                                                ></fa-icon>
                                                                            }
                                                                            <ng-container *ngIf="!utils.mobileViewActive">
                                                                                {{ 'shared.open' | translate }}
                                                                            </ng-container>
                                                                        </ion-button>
                                                                        @if (
                                                                            settingsSrv.currentUserRights.canManageTasks &&
                                                                            currentTaskViewMode === 'edit'
                                                                        ) {
                                                                            <ion-button
                                                                                size="small"
                                                                                color="danger"
                                                                                fill="clear"
                                                                                class="round dp-ml-s"
                                                                                (click)="onJobRemovedFromCurrentTask(jobIndex)"
                                                                            >
                                                                                <fa-icon icon="times"></fa-icon>
                                                                            </ion-button>
                                                                        }
                                                                    </ion-buttons>
                                                                </div>
                                                            }
                                                        </ion-chip>
                                                    </div>
                                                </div>
                                            </ion-col>
                                        </ng-container>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                        <ion-col size="12" size-lg="4">
                            <ion-card>
                                <ion-card-header>
                                    <ion-card-title
                                        >{{ 'tasks.details.status-title' | translate }}
                                        <ion-card-subtitle
                                            *ngIf="
                                                currentTaskFormGroup.get('startedAt')?.value ||
                                                currentTaskFormGroup.get('completedAt')?.value
                                            "
                                        >
                                            @if (
                                                currentTaskFormGroup.get('workingStatus')?.value === 'started' ||
                                                currentTaskFormGroup.get('startedAt')?.value > 0
                                            ) {
                                                <div class="status-info-text">
                                                    {{
                                                        'tasks.details.started-at-info'
                                                            | translate
                                                                : {
                                                                      date:
                                                                          currentTaskFormGroup.get('startedAt')?.value
                                                                          | date: 'dd.MM.yyyy - HH:mm',
                                                                  }
                                                    }}
                                                    <ion-button
                                                        class="info-hover-icon status-info-hover-icon"
                                                        size="small"
                                                        fill="clear"
                                                        dpTooltip
                                                        [tooltipContent]="currentTaskFormGroup.get('startedBy')?.value"
                                                        [tooltipTrigger]="
                                                            utils.mobileViewActive ? 'click mouseenter focus' : 'mouseenter focus'
                                                        "
                                                    >
                                                        <fa-icon icon="info-circle"></fa-icon>
                                                    </ion-button>
                                                </div>
                                            }
                                            @if (
                                                currentTaskFormGroup.get('workingStatus')?.value === 'done' &&
                                                currentTaskFormGroup.get('completedAt')?.value > 0
                                            ) {
                                                <div class="status-info-text">
                                                    {{
                                                        'tasks.details.done-at-info'
                                                            | translate
                                                                : {
                                                                      date:
                                                                          currentTaskFormGroup.get('completedAt')?.value
                                                                          | date: 'dd.MM.yyyy - HH:mm',
                                                                  }
                                                    }}
                                                    <ion-button
                                                        class="info-hover-icon status-info-hover-icon"
                                                        size="small"
                                                        fill="clear"
                                                        dpTooltip
                                                        [tooltipContent]="currentTaskFormGroup.get('completedBy')?.value"
                                                        [tooltipTrigger]="
                                                            utils.mobileViewActive ? 'click mouseenter focus' : 'mouseenter focus'
                                                        "
                                                    >
                                                        <fa-icon icon="info-circle"></fa-icon>
                                                    </ion-button>
                                                </div>
                                            }
                                        </ion-card-subtitle>
                                    </ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-chip
                                        class="status-chip"
                                        (click)="statusPopover.present($event)"
                                        [outline]="true"
                                        [color]="workingStatuses[currentTaskFormGroup.get('workingStatus').value].color"
                                        [disabled]="currentTaskViewMode === 'view'"
                                    >
                                        @switch (currentTaskFormGroup.get('workingStatus').value) {
                                            @case ('open') {
                                                {{ 'tasks.status.open' | translate }}
                                            }
                                            @case ('started') {
                                                {{ 'tasks.status.started' | translate }}
                                            }
                                            @case ('done') {
                                                {{ 'tasks.status.done' | translate }}
                                            }
                                        }
                                        <ion-icon class="status-chip-icon" name="chevron-down" size="small"></ion-icon>
                                    </ion-chip>
                                </ion-card-content>
                            </ion-card>
                            <ion-card *ngIf="settingsSrv.currentUserRights.canManageTasks || currentTaskResponsibleUserInfos.length > 0">
                                <ion-card-header>
                                    <ion-card-title>{{ 'tasks.details.responsible-title' | translate }}</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col
                                            size="12"
                                            *ngIf="settingsSrv.currentUserRights.canManageTasks && currentTaskViewMode === 'edit'"
                                        >
                                            <ion-input
                                                (click)="maybeToggleDrawer('responsible-users', $event)"
                                                mode="md"
                                                fill="outline"
                                                class="bg-light"
                                                [placeholder]="'tasks.details.form.select-user-placeholder' | translate"
                                                type="text"
                                                [readonly]="true"
                                            ></ion-input>
                                        </ion-col>
                                        <ion-col size="12">
                                            <div class="task-users">
                                                <div
                                                    class="task-user"
                                                    *ngFor="let user of currentTaskResponsibleUserInfos; index as userIndex"
                                                >
                                                    <ion-chip color="primary" class="task-user-chip">
                                                        <ion-label>{{ displayUserInfos(user) }}</ion-label>
                                                        <ion-button
                                                            *ngIf="
                                                                settingsSrv.currentUserRights.canManageTasks &&
                                                                currentTaskViewMode === 'edit'
                                                            "
                                                            size="small"
                                                            color="danger"
                                                            fill="clear"
                                                            class="round dp-ml-s"
                                                            (click)="onUserRemovedFromResponsibleList(userIndex)"
                                                        >
                                                            <fa-icon icon="times"></fa-icon>
                                                        </ion-button>
                                                    </ion-chip>
                                                </div>
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                            <ion-card *ngIf="settingsSrv.currentUserRights.canManageTasks">
                                <ion-card-header>
                                    <ion-card-title>{{ 'tasks.details.shared-title' | translate }}</ion-card-title>
                                </ion-card-header>
                                <ion-card-content>
                                    <ion-row>
                                        <ion-col size="12" *ngIf="currentTaskViewMode === 'edit'">
                                            <ion-input
                                                (click)="maybeToggleDrawer('user', $event)"
                                                mode="md"
                                                fill="outline"
                                                class="bg-light"
                                                [placeholder]="'tasks.details.form.select-user-placeholder' | translate"
                                                type="text"
                                                [readonly]="true"
                                            ></ion-input>
                                        </ion-col>
                                        <ion-col size="12">
                                            <ng-container *ngIf="sharingsToDelete.length > 0">
                                                <app-info-bar>
                                                    <div>
                                                        {{ 'tasks.details.shared-tasks-users-deleted' | translate }}
                                                    </div>
                                                    <div *ngFor="let sharing of sharingsToDelete">
                                                        {{ sharing.sharedWith.replace('user#', '') }}
                                                    </div>
                                                </app-info-bar>
                                            </ng-container>

                                            <div class="task-users">
                                                <div class="task-user" *ngFor="let user of currentTaskUserInfos; index as userIndex">
                                                    <ion-chip color="primary" class="task-user-chip">
                                                        <ion-label>{{ displayUserInfos(user) }}</ion-label>
                                                        <ion-button
                                                            *ngIf="currentTaskViewMode === 'edit'"
                                                            size="small"
                                                            color="danger"
                                                            fill="clear"
                                                            class="round dp-ml-s"
                                                            (click)="onUserRemovedFromCurrentTask(userIndex)"
                                                        >
                                                            <fa-icon icon="times"></fa-icon>
                                                        </ion-button>
                                                    </ion-chip>
                                                </div>
                                            </div>
                                        </ion-col>
                                    </ion-row>
                                </ion-card-content>
                            </ion-card>
                        </ion-col>
                    </ion-row>
                </ion-grid>
            </div>
        </ion-content>
        <ion-footer *ngIf="currentTaskViewMode === 'edit'">
            <ion-toolbar color="none">
                <ion-buttons slot="end" *ngIf="currentTaskFormGroup">
                    <ion-button size="small" fill="clear" color="warning" (click)="onCancelEditTask()">{{
                        'shared.cancel' | translate
                    }}</ion-button>
                    <ion-button fill="solid" color="success" (click)="onSaveCurrentTask()" [disabled]="!canSaveTask">
                        <fa-icon icon="check" slot="start"></fa-icon>
                        {{ 'shared.save' | translate }}
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-footer>
    </ng-template>
</ion-modal>

<!-- modal for showing detailed job information (editing, etc.) -->
<ion-modal
    class="detailed-job-modal stack-modal"
    [backdropDismiss]="false"
    [isOpen]="detailedJobModalVisible"
    (didDismiss)="detailedJobModalDismissed()"
>
    <ng-template>
        <ion-content class="ion-no-padding">
            <ng-container *ngIf="detailedJobModalJobData != null">
                <app-job-details
                    [job]="detailedJobModalJobData"
                    [taskId]="currentTaskFormGroup.get('_id').value"
                    [subView]="true"
                    [project]="detailedJobModalProjectData"
                    [serviceGroup]="detailedJobModalServiceGroupData"
                    [asDialog]="true"
                ></app-job-details>
            </ng-container>
        </ion-content>
    </ng-template>
</ion-modal>

@if (projectDownloading) {
    <ion-backdrop class="loading-project-backdrop"></ion-backdrop>
    <div class="loading-project-wrap">
        <app-loading-indicator>
            {{ 'tasks.details.project-data-loading' | translate }}
        </app-loading-indicator>
    </div>
}

<!-- popover for selecting status -->
<ion-popover #statusPopover trigger-action="manual" side="bottom" alignment="start">
    <ng-template>
        <ion-list lines="full">
            <ion-item [button]="true" (click)="changeStatus('open')">{{ 'tasks.status.open' | translate }}</ion-item>
            <ion-item [button]="true" (click)="changeStatus('started')">{{ 'tasks.status.started' | translate }}</ion-item>
            <ion-item [button]="true" (click)="changeStatus('done')">{{ 'tasks.status.done' | translate }}</ion-item>
        </ion-list>
    </ng-template>
</ion-popover>

<!--Drawer for selecting users and jobs -->
<app-select-drawer
    appendTo="ion-app"
    [multiple]="true"
    [items]="drawerItems"
    [stackModal]="true"
    [value]="drawerValue"
    [backdropDismiss]="false"
    (onChange)="onCurrentTaskDrawerItemsChanged($event)"
    #selectDrawer
></app-select-drawer>

<!-- SELECT PROJECT MODAL -->
<ion-modal [isOpen]="projectModalVisible" (ionModalDidDismiss)="projectModalVisible = false" class="modal-m stack-modal">
    <ng-template>
        <ion-header>
            <ion-toolbar color="none">
                <ion-title>{{ 'shared.select' | translate }}</ion-title>
                <ion-buttons slot="end">
                    <ion-button fill="clear" shape="round" color="primary" (click)="projectModalVisible = false">
                        <fa-icon slot="icon-only" icon="times"></fa-icon>
                    </ion-button>
                </ion-buttons>
            </ion-toolbar>
        </ion-header>
        <ion-content [scrollY]="false">
            <app-project-list
                style="height: 100%"
                mode="select"
                (projectSelectionChanged)="onCurrentTaskProjectIdChanged($event)"
            ></app-project-list>
        </ion-content>
    </ng-template>
</ion-modal>
